import type { Analytics } from '@segment/analytics-next'

import { config } from '@/config'

let pending: Promise<Analytics | undefined> | undefined

export async function loadAnalytics(): Promise<Analytics | undefined> {
	if (pending) return pending
	if (config.analyticsDisabled || !config.segment?.writeKey) return undefined

	pending = (async () => {
		const { AnalyticsBrowser } = await import('@segment/analytics-next')
		const [analytics] = await AnalyticsBrowser.load({
			writeKey: config.segment.writeKey,
			...(import.meta.env.DEV && { debug: true }),
		})
		return analytics
	})()

	return pending
}

export async function identifyUser(userId: string, traits?: Record<string, unknown>): Promise<void> {
	const analytics = await loadAnalytics()
	analytics?.identify(userId, traits)
}

export async function resetAnalytics(): Promise<void> {
	operatorContext = undefined
	const analytics = await loadAnalytics()
	analytics?.reset()
}

let operatorContext: { viewingOperatorId: number; viewingOperatorName: string } | undefined

export function setOperatorContext(operator: { id: number; name: string } | undefined, isGlobal: boolean): void {
	operatorContext = isGlobal && operator ? { viewingOperatorId: operator.id, viewingOperatorName: operator.name } : undefined
}

export async function trackPage(name?: string, properties?: Record<string, unknown>): Promise<void> {
	const analytics = await loadAnalytics()
	analytics?.page(name ?? undefined, { ...operatorContext, ...properties })
}

export async function track(event: string, properties?: Record<string, unknown>): Promise<void> {
	const analytics = await loadAnalytics()
	analytics?.track(event, { ...operatorContext, ...properties })
}
